import { render, staticRenderFns } from "./VerticalDivider.vue?vue&type=template&id=23faba04&scoped=true&"
import script from "./VerticalDivider.vue?vue&type=script&lang=js&"
export * from "./VerticalDivider.vue?vue&type=script&lang=js&"
import style0 from "./VerticalDivider.vue?vue&type=style&index=0&id=23faba04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23faba04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDivider,VRow})
